export interface Message<TData> {
  service: string;
  action: string;
  data: TData;
}

export class Command {
  private readonly service: string;
  private readonly action: string;

  constructor(service: string, action = '') {
    this.service = service;
    this.action = action;
  }

  forAction(action: string) {
    return new Command(this.service, action);
  }

  getMessage<TData>(data: TData): Message<TData> {
    return { service: this.service, action: this.action, data };
  }
}
